import {
  FETCH_AGENTS_ACTIVE_SUCCESS,
  FETCH_AGENTS_INACTIVE_SUCCESS,
  FETCH_AGENTS_INVITED_SUCCESS,
  FETCH_AGENTS_ERROR,
  FETCH_AGENTS_LOADING,
  SET_AGENT_DETAILS,
  UPDATE_AGENT_SUCCESS,
  SET_CLIENTS,
  SET_CLIENTS_ACTION_REQUIRED,
  SET_CLIENT_DETAILS,
  INVITE_AGENT_SUCCESS,
  CANCEL_INVITE_SUCCESS,
  FETCH_ALL_AGENTS_ACTIVE_SUCCESS,
  SET_ROUTE_TO_REDIRECT,
  RESEND_INVITATION_SUCCESS,
} from '@/app/admin/store/types';

export const mutations = {
  [FETCH_AGENTS_LOADING]: (state) => {
    state.agentsLoadingStatus = true;
  },
  [FETCH_AGENTS_ERROR]: (state) => {
    state.agentsLoadingStatus = false;
  },
  [FETCH_AGENTS_ACTIVE_SUCCESS]: (state, data) => {
    state.agentsLoadingStatus = false;
    state.agentsActive = data;
  },
  [FETCH_AGENTS_INVITED_SUCCESS]: (state, data) => {
    state.agentsLoadingStatus = false;
    state.agentsInvited = data;
  },
  [FETCH_AGENTS_INACTIVE_SUCCESS]: (state, data) => {
    state.agentsLoadingStatus = false;
    state.agentsInactive = data;
  },
  [SET_AGENT_DETAILS]: (state, data) => {
    state.agentDetails = data;
  },
  [UPDATE_AGENT_SUCCESS]: (state, data) => {
    state.agentDetails = {
      ...state.agentDetails,
      isActive: data.updateData.isActive,
    };
  },
  [SET_CLIENTS]: (state, clients) => {
    state.clients = clients;
  },
  [SET_CLIENTS_ACTION_REQUIRED]: (state, clients) => {
    state.clientsActionRequired = clients;
  },
  [SET_CLIENT_DETAILS]: (state, data) => {
    state.clientDetails = data;
  },
  [INVITE_AGENT_SUCCESS]: (state) => {
    state.agentsLoadingStatus = false;
  },
  [CANCEL_INVITE_SUCCESS]: (state) => {
    state.agentsLoadingStatus = false;
  },
  [FETCH_ALL_AGENTS_ACTIVE_SUCCESS]: (state, data) => {
    state.allAgentsActive = data;
  },
  [SET_ROUTE_TO_REDIRECT]: (state, routeName) => {
    state.routeToRedirect = routeName;
  },
  [RESEND_INVITATION_SUCCESS]: (state) => {
    state.agentsLoadingStatus = false;
  },
};
